import { resource } from "./resource";
import type { DocumentPreviewResponse } from "./document-preview-api";

export type EmailAudience = "customer" | "contractor" | "company";

interface EmailVariant {
  key: string;
  label: string;
}

export interface EmailSetting {
  kind: string;
  name: string;
  audience: EmailAudience;
  description: string;
  variants: EmailVariant[] | null;
  customisable: boolean;
  opening_note: string;
  closing_note: string;
}

interface EmailCopyUpdate {
  opening_note: string;
  closing_note: string;
}

export const getEmailSettings = (
  signal?: AbortSignal,
): Promise<EmailSetting[]> =>
  resource<EmailSetting[]>("/api/admin/email-settings", "emails").get(signal);

export const saveEmailSetting = (
  kind: string,
  copy: EmailCopyUpdate,
): Promise<EmailSetting> =>
  resource<EmailSetting>(
    `/api/admin/email-settings/${encodeURIComponent(kind)}`,
    "email",
  ).put(copy);

export const getEmailPreview = (input: {
  kind: string;
  variant?: string;
  opening_note: string;
  closing_note: string;
  /**
   * Wraps the note regions in contenteditable data-note markers (empty ones
   * included) for the in-place editor. Ignored for non-customisable kinds.
   */
  editable?: boolean;
}): Promise<DocumentPreviewResponse> =>
  resource<DocumentPreviewResponse>("/api/admin/email-preview").post({
    ...input,
    variant: input.variant ?? "",
  });
